import React from "react";
import "./index.scss";

export default function Footer() {
  return (
    <React.Fragment>      
      <footer>
        
        <div class="copyRight">
          <hr />
          Copyright ©2026 北京竹事咨询有限公司
          <a
            href="http://beian.miit.gov.cn"
            target="_blank"
            style={{ color: "#ffffffcc", marginLeft: 10 }}
          >
            京ICP备2026008572号-1
          </a>
        </div>
      </footer>
    </React.Fragment>
  );
}
